import { IAdvancedUserUpload } from "./DocumentTableInterfaces";
import "./css/DocumentTable.css";
import { faIndustry } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function AdvancedUserUpload({ document }: IAdvancedUserUpload) {
  const disabled = !document.advancedUserUpload;

  return (
    <span
      id="mainPageKey"
      title={disabled ? "Uploaded by BasicUser" : "Uploaded by AdvancedUser"}
      style={{ color: disabled ? "#ced4da" : "#212529" }}
    >
      <FontAwesomeIcon icon={faIndustry} />
    </span>
  );
}
